import { useState } from "react";
import { Loader2 } from "lucide-react";
import { useAuthStore } from "@/store/authStore";
import { SettingsRow } from "@/modules/standardAgent/components/SettingsRow";
import { Switch } from "@/components/ui/switch";

/**
 * The personal opt-out for quote-view notifications: whether this user is
 * emailed when a customer opens a quote on an opportunity they own.
 * @returns The settings row element
 */
export function QuoteViewNotificationsRow() {
  const user = useAuthStore((state) => state.user);
  const updateProfile = useAuthStore((state) => state.updateProfile);
  const [isSaving, setIsSaving] = useState(false);

  const handleChange = async (enabled: boolean) => {
    setIsSaving(true);
    try {
      await updateProfile({ quoteViewNotificationsEnabled: enabled });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <SettingsRow
      id="personal-quote-view-notifications"
      label="Quote views"
      description="Email me when a customer opens a quote on one of my opportunities."
    >
      <div className="flex items-center gap-2">
        {isSaving && (
          <Loader2 className="h-3.5 w-3.5 animate-spin text-muted-foreground" />
        )}
        <Switch
          checked={user?.quoteViewNotificationsEnabled ?? true}
          onCheckedChange={handleChange}
          disabled={isSaving}
          aria-label="Quote view notifications"
        />
      </div>
    </SettingsRow>
  );
}
